const PLACEHOLDER_PATTERN = /^(\[[A-Za-z0-9_]+\])$/;

type KbSectionClausePreviewProps = {
  readonly content: string;
  readonly className?: string;
};

export const KbSectionClausePreview = ({
  content,
  className,
}: KbSectionClausePreviewProps) => {
  const parts = content.split(/(\[[A-Za-z0-9_]+\])/g);

  return (
    <div
      className={
        className ??
        "whitespace-pre-wrap text-[11px] leading-relaxed text-foreground"
      }
    >
      {parts.map((part, index) =>
        PLACEHOLDER_PATTERN.test(part) ? (
          <mark
            key={`${index}-${part}`}
            className="rounded border border-amber-200 bg-amber-100 px-1 py-0.5 font-mono text-[10px] font-semibold text-amber-900"
          >
            {part}
          </mark>
        ) : (
          <span key={`${index}-text`}>{part}</span>
        ),
      )}
    </div>
  );
};
